export default "/images/9234826ce1c1fa244dc674d3a51c1435.jpg";